import React from 'react'
import { Navigate } from 'react-router-dom'
import { reverseUrl } from '../../reverseUrl'
import { useAuth } from '../../../hooks/useAuth'
import { SpinnerWrapper } from '../../../components/common/SpinnerWrapper'
import { useFeatures } from '../../../hooks/useFeatures'

interface AuthenticatedRouteProps {
  children: React.ReactNode
}

const AuthenticatedRoute = ({
  children,
}: AuthenticatedRouteProps): JSX.Element | null => {
  const { userId, userIsVerified, isLoading } = useAuth()
  const { isLoading: isLoadingFeatures } = useFeatures()

  if (isLoading || isLoadingFeatures) {
    return <SpinnerWrapper />
  }
  if (!userId) {
    return <Navigate to={reverseUrl('login')} />
  }

  if (!userIsVerified && typeof userIsVerified !== 'undefined') {
    return <Navigate to={reverseUrl('verify-email')} />
  }

  return <>{children}</>
}

AuthenticatedRoute.displayName = 'AuthenticatedRoute'
export { AuthenticatedRoute }
